module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-pink-1af6391e09a1465e2ee4c910f0e03681.svg";